module.exports = __webpack_public_path__ + "static/media/granodetrigo.9207e4d4.png";